import React from 'react'
import ProtectedRoute from '../../wrappers/ProtectedRoutes'
import { AdminLayout } from '../../layouts/DashboardLayout'
import { Navigate, Route, Routes } from 'react-router-dom'
import DashboardPage from '../../pages/DashboardPage'
import FeaturesRoutes from '../features'

export default function EntrepriseProtectedNav() {
    return (
        <ProtectedRoute allowedRoles={["entreprise"]}>
            <AdminLayout>
                <Routes>
                    <Route path="/dashboard" element={<DashboardPage />} />
                    {/* Routes pour Support */}
                    <Route path="/*" element={<FeaturesRoutes />} />
                    {/* Redirection par défaut */}
                    <Route path="*" element={<Navigate to="/entreprise/dashboard" replace />} />
                </Routes>
            </AdminLayout>
        </ProtectedRoute>
    )
}